<template>
    <div class="col-12">
        <table-search-and-pagination
            :table-data="users"
            @dataUpdated="queriedData = $event"
        >
            <div slot="header" class="flex-end">
                <base-button type="primary" @click="createUserModal = true">
                    Add User
                </base-button>
            </div>
            <el-table
                v-if="users.length"
                style="width: 100%"
                max-height="500"
                :data="queriedData"
                @row-click="editUser"
            >
                <el-table-column
                    v-for="column in tableColumns"
                    :key="column.label"
                    :min-width="column.minWidth"
                    :prop="column.prop"
                    :label="column.label"
                    :formatter="column.formatter"
                    :show-overflow-tooltip="true"
                />
            </el-table>
        </table-search-and-pagination>
        <modal
            :show.sync="createUserModal"
            body-classes="p-0"
            modal-classes="modal-sm"
        >
            <card class="mb-0 card-form">
                <template slot="header">
                    <h2 class="modal-title">Add User</h2>
                    <button
                        type="button"
                        class="close"
                        aria-label="Close"
                        @click="createUserModal = false"
                    >
                        <i class="tim-icons icon-simple-remove" />
                    </button>
                </template>
                <user-add-form
                    :customers="customers"
                    :designers="designers"
                    :user-roles="userRoles"
                    :reset="!createUserModal"
                    :user-added="userAdded"
                    :available-username="availableUsername"
                    @searchDesigners="$emit('searchDesigners', $event)"
                    @searchCustomers="$emit('searchCustomers', $event)"
                    @close="createUserModal = false"
                    @getAvailableUsername="getAvailableUsername"
                    @createUser="createUser"
                />
            </card>
        </modal>
    </div>
</template>
<script>
import { Modal } from "src/components/UI";
import TableSearchAndPagination from "src/components/TableSearchAndPagination";
import UserAddForm from "./UserAddForm.vue";

export default {
    name: "Users",
    components: {
        UserAddForm,
        Modal,
        TableSearchAndPagination,
    },
    props: {
        users: {
            type: Array,
            required: true,
        },
        customers: {
            type: Array,
            required: true,
        },
        designers: {
            type: Array,
            required: true,
        },
        userRoles: {
            type: Array,
            required: true,
        },
        userAdded: {
            type: Boolean,
            required: true,
        },
        availableUsername: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            queriedData: [],
            createUserModal: false,
            tableColumns: [
                {
                    prop: "fullName",
                    label: "Name",
                    formatter: (row) => this.formatName(row),
                },
                {
                    prop: "customer_name",
                    label: "Customer",
                },
                {
                    prop: "username",
                    label: "Username",
                },
                {
                    prop: "role",
                    label: "Role",
                },
                {
                    prop: "status",
                    label: "Status",
                },
            ],
        };
    },
    methods: {
        editUser(row) {
            this.$router.push(`/user/${row.id}`);
        },
        createUser(user) {
            this.$emit("createUser", user);
        },
        getAvailableUsername(data) {
            this.$emit("getAvailableUsername", data);
        },
        formatName(row) {
            return row.first_name + " " + row.last_name;
        },
    },
};
</script>
